export const intersectRect = (rectA, rectB) => {
    return !(
        rectB.left >= rectA.right ||
        rectB.right <= rectA.left ||
        rectB.top >= rectA.bottom ||
        rectB.bottom <= rectA.top
      );
}

export const rndAction = () => {
  return Math.random() < 0.3
}

export const rndBool = () => {
  return Math.random() < 0.5
}

export const scrollToAchor = (itemId, isOpen) => {
    const itemNode = document.getElementById(itemId)

    if (itemNode){
        itemNode.scrollIntoView({block: 'start', behavior: 'smooth', inline: "nearest"})
    }
    
    if(isOpen){
      isOpen.set(false)
    }
}